module.exports = __webpack_public_path__ + "img/level-select.c152530a.png";